<template>
  <div class="mt-10 max-w-6xl mx-auto">
    <div class="Polaris-LegacyCard">
      <div class="Polaris-LegacyCard__Header">
        <h2 class="Polaris-Text--root Polaris-Text--headingLg">
          Frequently asked questions
        </h2>
      </div>
      <div class="Polaris-LegacyCard__Section">
        <AccordianItem
          v-for="(faq, index) of faqs"
          :key="index"
          :title="faq.title"
          :content="faq.content"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AccordianItem from "../../components/Common/AccordianItem";

export default {
  components: {
    AccordianItem
  },
  data() {
    return {
      faqs: [
        {
          title: "What are all the languages available?",
          content:
            "You can send messages in English, Portguese, Spanish, Italian, French, Indonesian, German, Arabic, Turkish, Hebrew and Dutch"
        },
        {
          title: "Will I be charged for failed messages?",
          content:
            "No, if that’s not a WhatsApp number or if we couldn’t deliver a message we wouldn’t count that message."
        },
        {
          title: "Will the automated messages go from my number?",
          content:
            "WhatsApp needs a Business API approval and hence it will be sent from one of our numbers, but we will also add your number in all messages so they can reach you with a click."
        },
        {
          title: "Can I send WhatsApp messages to everybody?",
          content:
            "You can only send it to people who have opted in via checkout."
        },
        {
          title: "Will I get charged for the trial period?",
          content:
            "If you enable automation you will be charged for the messages you send. Base fare 9.99 or 29 will not be charged on the trial period."
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
